import { Component } from '@angular/core';
import { AbstractAdvancedInput } from '../abstract-advanced-input';

@Component({
  templateUrl: 'advanced-number-input.component.html',
  standalone: false,
})
export class AdvancedNumberInputComponent extends AbstractAdvancedInput {
  public set value(val: any) {
    if (this._value == val && !this.configuration?.alwaysEmitChanges) {
      return;
    }
    this._value = val;
    this.currentValueChange.emit(this._value);
  }

  public get value(): any {
    return this._value;
  }
}
